import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import UploadQuestionBank from './submodules/create/Create';

const QuestionsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			{/* <AuthorizedRoute
				entity={DASHBOARD_RESOURCES.tournament}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].getTournaments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListTournament}
				exact
			/> */}
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.questionBank}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.questionBank].saveQuestionBank]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/upload`}
				component={UploadQuestionBank}
				exact
			/>

			<Redirect to={`${path}/upload`} />
		</Switch>
	);
};

export default QuestionsDashboard;
